<template>
  <div class="flex justify-between
              md:-mx-2 lg:-mx-6 bg-highlight rounded py-4 px-6 text-sm text-text-label">
    <span>{{ $moment(date, 'DD-MM-YYYY').locale($i18n.locale).format(formatString) }}</span>
    <span v-if="transactions.length !== 0" class="font-bold text-money">
      {{ valueDisplay }}
    </span>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "TransactionDate",
  props: {
    date: {
      type: String,
      required: true
    },
    transactions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
    ...mapGetters('space', ['spaceInfo']),
    formatString() {
      const currentYear = this.$moment().format('YYYY');
      const dateYear = this.$moment(this.date, 'DD-MM-YYYY').format('YYYY')
      return dateYear === currentYear ? 'D MMMM' : 'D MMMM YYYY'
    },
    totalInDay() {
      const calculateTransactionsSumReducer = (acc, transaction) => {
        return transaction.type === 1 ? acc + transaction.sum_base : acc - transaction.sum_base
      }
      return [...this.transactions].reduce(calculateTransactionsSumReducer, 0)
    },
    valueDisplay() {
      return this.displayCurrencyValue(this.totalInDay, this.spaceInfo.currency);
    }
  }
}
</script>

<style scoped>
.text-money {
  color: #aaa;
}
</style>